<a [class.hasText]="hasText" #elementRef class="fab-action-button-item {{ disabled ? 'disabled' : '' }}" (click)="emitClickEvent($event)" [ngClass]="buttonClass">
    @if (contentTpl) {
        <ng-container [ngTemplateOutlet]="contentTpl.templateRef"></ng-container>
    } @else {
        <fa-icon [icon]="[faPrefix, faIcon]" size="lg"></fa-icon>
        <span>{{ content }}</span>
    }
</a>
